module.exports = __webpack_public_path__ + "static/img/offline.e8386681.png";